import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

export const StyledTop = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.m}px;
`;

export const StyledMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const StyledCover = styled.div.withConfig({ shouldForwardProp })<{ $image?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.backgroundTertiary};
  background-image: ${({ $image }) => ($image ? `url(${$image})` : 'none')};
  background-size: cover;
  background-position: center;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: ${({ theme }) => theme.fontSizes.l}px;
  text-transform: uppercase;
`;

export const StyledInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;
  flex: 1;
  padding-right: ${({ theme }) => theme.spacing.l}px;
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  min-width: 0;
`;

export const StyledTitleText = styled.span`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: ${({ theme }) => theme.fontSizes.l}px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const StyledStateBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}px;
  margin-top: ${({ theme }) => theme.spacing.m}px;
`;

export const StyledStateRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  row-gap: ${({ theme }) => theme.spacing.xxs}px;
`;

export const StyledMeta = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const StyledCaption = styled.span.withConfig({ shouldForwardProp })<{ $warning?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  color: ${({ theme, $warning }) => ($warning ? theme.colors.warning : theme.colors.textMuted)};
`;

export const StyledPinnedDot = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
`;

export const StyledActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m}px;
  margin-top: ${({ theme }) => theme.spacing.m}px;
  padding-top: ${({ theme }) => theme.spacing.m}px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

export const StyledActionButtons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;

  > button {
    flex: 1 1 auto;
    padding: 0 ${({ theme }) => theme.spacing.s}px;
  }
`;

export const StyledSwitchRow = styled.div`
  display: flex;
  justify-content: center;
`;
